import Modal from "react-bootstrap/Modal";
import { useContext, useState } from "react";
import Button from "react-bootstrap/Button";
import { Form } from "react-bootstrap";
import ConfirmDialogButton from "./ConfirmDialogButton";
import { LanguageContext } from "../../utils/Language";

function ConfirmDialogButtonWithEdit(props) {
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [note, setNote] = useState("");
  const { dictionary } = useContext(LanguageContext);

  const handleOk = () => {
    props.onClick(note);
    setShowEditDialog(false);
  };

  return (
    <>
      <Button
        variant={props.variant}
        style={props.style}
        onClick={() => setShowEditDialog(true)}
        disabled={props.disabled}
      >
        {props.children}
      </Button>

      <Modal
        show={showEditDialog}
        onHide={() => setShowEditDialog(false)}
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>{props.noteTitle}</Form.Label>
              <Form.Control
                as="textarea"
                name="Note"
                rows="5"
                onChange={(e) => setNote(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditDialog(false)}>
            {dictionary.Cancel}
          </Button>
          <ConfirmDialogButton
            variant="primary"
            title={props.title}
            body={props.body}
            onClick={handleOk}
          >
            {dictionary.Accept}
          </ConfirmDialogButton>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ConfirmDialogButtonWithEdit;
